import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { unknownChipTitle } from '../../../../../play-core/models/search/MediaSearchResponse';
import { hideScrollbar } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { Chip } from '../../../components/Chip/Chip';
import { useFilterChips } from '../../../components/MediaSearch/use-filter-chips';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { useSearchDispatch, useSearchState } from '../SearchContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchFilterChips = () => {
  const dispatch = useSearchDispatch();
  const {
    query,
    mediaResult,
    mediaLoading
  } = useSearchState();
  const chips = useFilterChips(query, mediaResult, dispatch);
  return /*#__PURE__*/_jsx(Fragment, {
    children: !!chips.length && /*#__PURE__*/_jsx(StyledPlayContainer, {
      width: "small",
      children: /*#__PURE__*/_jsx(Container, {
        children: chips.filter(chip => !(mediaLoading && chip.title === unknownChipTitle)).map(item => /*#__PURE__*/_jsx(Chip, {
          ...item
        }, item.id))
      })
    })
  });
};
const StyledPlayContainer = styled(PlayContainer).withConfig({
  displayName: "SearchFilterChips__StyledPlayContainer",
  componentId: "sc-m1ypw7-0"
})(["overflow:hidden;"]);
const Container = styled.div.withConfig({
  displayName: "SearchFilterChips__Container",
  componentId: "sc-m1ypw7-1"
})(["display:flex;flex-wrap:wrap;", "{flex-wrap:nowrap;overflow-x:auto;", ";padding:0 8px 16px;}", "{& > *{margin-top:16px;}}"], Viewports.for('small'), hideScrollbar(), Viewports.for('mediumUp'));